import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <h1 className="font-heading text-8xl font-bold text-foreground-950 md:text-9xl">404</h1>
      <h2 className="mt-6 text-xl font-semibold text-foreground-900 md:text-2xl">
        Page not found
      </h2>
      <p className="mt-2 text-sm text-foreground-500">{location.pathname}</p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
      >
        Back to home
        <i className="ri-arrow-left-line"></i>
      </Link>
    </div>
  );
}